export default {
	name: 'ModalInfoEventoCalendario',
	props: ['eventoInfo', 'loading', "isReadOnly"],
	emits: ['click:close', 'click:edit-evento', 'click:delete-evento'],
	methods: {
		formatarIntervaloDeData(dataInicio, dataFim) {
			const opcoesData = {
				day: 'numeric',
				month: 'long',
				year: 'numeric',
			}

			const opcoesHora = {
				hour: '2-digit',
				minute: '2-digit',
				hour12: false,
			}

			const formatadorData = new Intl.DateTimeFormat('pt-BR', opcoesData)
			const formatadorHora = new Intl.DateTimeFormat('pt-BR', opcoesHora)

			const dataFormatada = formatadorData.format(dataInicio)
			const horaInicioFormatada = formatadorHora.format(dataInicio)
			const horaFimFormatada = formatadorHora.format(dataFim)

			return `${dataFormatada} ${horaInicioFormatada} - ${horaFimFormatada}`
		},
		onClickCancelarEvento() {
			this.$emit(
				'click:delete-evento',
				this.eventoInfo?.extendedProps?.idEventoOriginal || null
			)
		},
	},
	computed: {
		dataEventoFormatada() {
			const dataInicio = this.eventoInfo?.extendedProps?.dataEventoInicio
				? new Date(this.eventoInfo?.extendedProps?.dataEventoInicio)
				: null
			const dataFim = this.eventoInfo?.extendedProps?.dataEventoFim
				? new Date(this.eventoInfo?.extendedProps?.dataEventoFim)
				: null

			if (!dataInicio || !dataFim) return ''
			return this.formatarIntervaloDeData(dataInicio, dataFim)
		},

		locationEventoFormatada() {
			return this.eventoInfo?.extendedProps?.localEvento || ''
		},

		organizadorEvento() {
			
			if (this.eventoInfo?.extendedProps?.isOrganizador) {
				return 'Você é o organizador'
			}
			return 'Você não é o organizador'
		},

		membrosEvento() {
			if (this.eventoInfo?.extendedProps?.membrosEventos) {
				return this.eventoInfo?.extendedProps?.membrosEventos
			}
		},
	},
	watch: {},
	template: `
        <section 
            class="modal--content rounded-md relative flex-1 !w-full !h-max overflow-[initial]" 
            data-id="modal_info_evento_calendario"
            id="modal_info_evento_calendario">

            <q-btn icon="close" size="lg" rounded class="absolute top-4 right-4 text-primary-pure"  @click="$emit('click:close')"/>

            <div class="bg-primary-pure w-full h-4">
            </div>

            <div class="
                flex
                flex-col
                !gap-y-16
                w-full 
                h-full 
                overflow-auto 
                p-20
                mt-10 
                border 
                border-transparent">
                <h1 class="text-title-4 text-bold">Calendário</h1>

                <div class="flex items-center gap-4 w-full">
                    <q-icon name="calendar_month" color="primary" size="md"/>

                    <p class="text-title-4">{{eventoInfo?.title || ""}}</p>
                </div> 

                <q-btn 
                    icon="videocam" 
                    color="primary" 
                    label="ingressar" 
                    :href="eventoInfo?.extendedProps?.urlTeams || ''" 
                    class="btn h-48"/>

                <div class="bg-neutral-40 w-full h-1 rounded"></div>

                <div class="flex items-center w-full gap-12">
                    <q-icon name="timer" size="md"/>

                    <p class="text-title-4">{{dataEventoFormatada || ''}}</p>
                </div>

                <div class="bg-neutral-40 w-full h-1 rounded"></div>

                <div class="flex items-center w-full gap-12">
                    <q-icon name="location_on" size="md"/>

                    <p class="text-title-4">{{locationEventoFormatada || ''}}</p>
                </div>

                <div class="bg-neutral-40 w-full h-1 rounded"></div>

                <div class="flex items-start w-full gap-12">
                    <q-icon name="group" size="md"/>

                    <div class="flex flex-col !gap-y-4">
                        <p class="text-title-4">{{organizadorEvento}}</p>
                        <span 
                            v-for="(membro, index) in membrosEvento || []" 
                            :key="index" 
                            class="text-body-2 text-paragraph-3 text-neutral-70">{{membro.email}} - {{membro.status}}</span>
                    </div>
                </div>

                <div v-if="!isReadOnly" class="flex justify-center items-center w-full !gap-x-20">
                    <q-btn class="btn !min-w-[7rem] h-48 secondary" size="md" :disabled="loading" @click="$emit('click:edit-evento', eventoInfo?.id || null)">
                        <q-icon name="edit"/>
                        <span>Editar</span>
                    </q-btn>
                    <q-btn class="btn min-w-[7rem] h-48 primary" size="md" @click="onClickCancelarEvento" :loading="loading">
                        <q-icon name="cancel_presentation"/>
                        <span>Cancelar</span>
                    </q-btn>
                   
                </div>
            </div>
        </section>
    `,
}
